import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function VisuallyHiddenPageTitle({ children }: Props) {
  return <h1 className="sr-only">{children}</h1>;
}
